export const environment = {
  production: true,
  baseUrl: 'https://connect.rhinoartisan.com',
  apiUrl: 'https://api.rhinoartisan.com',
  defaultAvatar: 'https://storage.googleapis.com/2shapes/defaults/avatar.png',
  googleClientId: '798367870289-9c6fndjcvsrgebrrm1uphkubjok56ggh.apps.googleusercontent.com' // Replace this with your actual Google Client ID
};
